export default {
  tooltip_title: 'Klik for at kopiere',
  success: 'Kopieret!',
};
